import script from "./moveFolder.vue?vue&type=script&setup=true&lang=js"
export * from "./moveFolder.vue?vue&type=script&setup=true&lang=js"

import "./moveFolder.vue?vue&type=style&index=0&id=3841c92e&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3841c92e"]])

export default __exports__